export enum OPERATION_TYPE {
  DELEGATE = 'DELEGATE',
}

// A record of extra parameter labels, params that aren't here won't be shown by the extraParams component
export const EXTRA_PARAMS_LABELS: Record<
  OPERATION_TYPE,
  Record<string, string>
> = {
  // ExtraParams parsing for Standardized Staking Operations
  [OPERATION_TYPE.DELEGATE]: {
    // BTC Extra Params
    timelockBlocks: 'Duration',
    babylonAddressForRewards: 'Reward recipient',

    // Starknet Extra Params
    rewardAddress: 'Reward recipient',
    redelegateSrc: 'Redelegation source',

    // Avalanche Extra Params
    startTime: 'Start time',
    endTime: 'End time',
    delegatorRewardsAddress: 'Delegator reward recipient',
    validatorRewardsAddress: 'Validator reward recipient',
    duration: 'Duration',

    // BNB (BSC) Extra Params
    shares: 'Shares',
    delegateVotePower: 'Delegate vote power',
  },
};
